// Feature flags. Flip to true to re-enable a feature across the app.

// Voice lessons are hidden until the voice pipeline is reworked.
// When false: lessons always start in text mode, the mode picker and the
// preferred-class-type setting are hidden, and voice lesson state is ignored.
export const VOICE_MODE_ENABLED = false;
